import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedHTMLMessage } from 'react-intl'
import { get } from 'lodash'
import { TrainingAndPracticeArray } from 'components/forms'
import { FormDebug, Note, Title } from 'components/misc'
import { MaterialModal, ElevatedButton } from 'components/layout'
import { apiDashboard } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import validate from './training-and-practice.validation'
import { initialValuesPQ } from 'models/adventurousJourney'
import { ACTIVITY_STATES } from '../../../../constants/enums'

@form({
  form: 'updatePreparationAndTraining',
  disableHook: true,
  validate
})
@apiDashboard.apiAdventurousJourney({
  loaders: ['setup'],
  refreshKey: 'awardId'
})
@connect(({ api }) => ({
  preparationAndTrainings: get(
    api,
    'dashboard.adventurousJourney.data.ajPreparationAndTrainingList'
  )
}))
class TrainingAndPractice extends Component {
  static propTypes = {
    awardId: PropTypes.any,
    onPracticeAndTraining: PropTypes.func,
    handleSubmit: PropTypes.func,
    initialize: PropTypes.func,
    change: PropTypes.func,
    preparationAndTrainings: PropTypes.array,
    setupStatus: PropTypes.object,
    values: PropTypes.object,
    errors: PropTypes.object,
    colorClass: PropTypes.string,
    noFooter: PropTypes.bool,
    noHeader: PropTypes.bool,
    disabled: PropTypes.bool,
    submitting: PropTypes.bool,
    ajPrepAndTrainState: PropTypes.string
  }

  componentDidMount() {
    this.handleInitializePQ(this.props.preparationAndTrainings)
  }

  componentWillReceiveProps = nextProps => {
    if (
      !this.props.preparationAndTrainings &&
      nextProps.preparationAndTrainings
    ) {
      this.handleInitializePQ(this.props.preparationAndTrainings)
    }
  }

  handleInitializePQ = preparationAndTrainings => {
    this.props.initialize(initialValuesPQ(preparationAndTrainings))
  }

  handleSubmit = fields => {
    const { onPracticeAndTraining, awardId } = this.props

    return onPracticeAndTraining(awardId, fields, { resetForm: () => {} })
  }

  handleApproval = () => {}

  handleDeleteItem = item => {
    const { values } = this.props

    let deleted = get(values, 'deleted')

    if (deleted && Array.isArray(deleted)) {
      deleted.push(item)
    } else {
      deleted = [item]
    }

    this.props.change('deleted', deleted)
  }

  render() {
    const {
      handleSubmit,
      noFooter,
      noHeader,
      setupStatus,
      colorClass,
      values,
      errors,
      disabled,
      submitting,
      ajPrepAndTrainState
    } = this.props

    const disableButtons = ajPrepAndTrainState === ACTIVITY_STATES.award_leader_singoff.id

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        {!noHeader && (
          <Note>
            <FormattedHTMLMessage
              id="label.before_you_head_to_journey"
              defaultMessage="Before you head to your Journey you first need some preparation and training. Complete all these activities to prove that you are ready."
            />
          </Note>
        )}
        <Title h5 colorClass={colorClass}>
          <FormattedHTMLMessage
            id="formTitle.preparation_and_training_activities"
            defaultMessage="Preparation and Training Activities"
          />
        </Title>

        <TrainingAndPracticeArray name="def" disabled={disabled} />

        <Title h5 colorClass={colorClass}>
          <FormattedHTMLMessage
            id="formTitle.added_preparation_activities"
            defaultMessage="Added Preparation and Training Activities"
          />
        </Title>
        {!disabled && (
          <Note>
            <FormattedHTMLMessage
              id="label.here_you_can_add_activity"
              defaultMessage="Here you can add some extra P&T activity."
            />
          </Note>
        )}
        <TrainingAndPracticeArray
          name="userAdded"
          showAdd
          showDelete
          disabled={disabled}
          colorClass={colorClass}
          disableButtons={disableButtons}
        />
        <FormDebug values={values} errors={errors} />
        {noFooter ? (
          <div
            style={{
              paddingTop: 15,
              marginTop: 5,
              marginBottom: 180,
              borderTop: '1px solid #ccc'
            }}
          >
            <ElevatedButton
              colorClass={colorClass}
              intlKey="button.update"
              uppercase
              fullWidth
              submit
              disabled={disabled || disableButtons}
              isLoading={submitting}
            >
              Update
            </ElevatedButton>
          </div>
        ) : (
          <MaterialModal.Footer
            action="Update"
            actionKey="button.update"
            colorClass={colorClass}
            insideContent
            loading={get(setupStatus, 'loading')}
            disabled={disableButtons}
          />
        )}
      </form>
    )
  }
}

export default TrainingAndPractice
